import { useSelector } from "react-redux";
import { Box, Stack, Typography } from "@mui/material"
import moment from "moment";
import BaseImage from "../BaseImage"
import ReviewSwitch from "../ReviewSwitch";
import LockStatusSwitch from "../LockStatusSwitch";
import FirstFellowSwitch from "../FirstFellowSwitch";
import { DEMO_REPORTS } from "../SectionHealthReport";
import usePermissions from "../../hooks/use-permissions";
import { ViewPermissions } from "../../constants";


const PatientReportsList = ({ isMyPatient, reports, refetchReports }) => {
  const auth = useSelector(state => state.auth)
  const isStaffPhysician = useSelector(state => state.isStaffPhysician)
  const isAdminStaffPhysician = useSelector(state => state.isAdminStaffPhysician)
  const STAFF_VIEW_ROLES = ['MANAGER', 'SALES']
  const isStaff = isStaffPhysician || isAdminStaffPhysician ||
    auth?.roles?.some(r => STAFF_VIEW_ROLES.includes(r))
  const {myPermissions} = usePermissions();

  return (
    <Stack direction={'column'} spacing={'8px'}>
      {reports && reports?.map((item => (
        <Box
          key={item.id}
          sx={{
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'primary.lightGray',
            boxShadow: '0px 2px 10px 0px #5B87EF33'
          }}
        >
          <Box
            sx={{
              padding: '16px',
              borderRadius: '0 0 8px 8px'
            }}
          >
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <BaseImage
                sx={{
                  minWidth: '30px',
                  width: '30px',
                  height: '30px',
                }}
                src={DEMO_REPORTS.find(report => report.name === item?.name)?.icon}
                alt={item?.name}
              />
            </Box>
            <Box
              sx={{
                mt: '8px'
              }}
            >
              <Typography variant="h4">
                {item?.name}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant="body" color="primary.darkGray">
                {moment(item?.updatedAtOrg).format('MM/DD/YYYY')}
              </Typography>
              <Box
                sx={{
                  textAlign: 'center',
                  bgcolor: item.priority === 0 ? 'primary.lightGreen1' : 'primary.lightRed',
                  padding: '1px 7px',
                  borderRadius: '4px'
                }}
              >
                <Typography
                  variant="subText"
                  color={item?.priority === 0 ? "primary.darkGreen" : "primary.red"}
                >
                  {`${item?.priority || 0} Priority`}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              borderTop: '1px solid',
              borderColor: 'primary.lightGray',
              padding: '12px',
              display: isStaff ? 'flex' : 'none',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <ReviewSwitch
              reportId={item.id}
              needsReview={item?.needsReview}
              refetchReports={refetchReports}
            />
          </Box>
          <Box
            sx={{
              display: (!isStaff || isMyPatient) ? 'flex': 'none',
              borderTop: '1px solid',
              borderColor: 'primary.lightGray',
              padding: '12px',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <LockStatusSwitch
              row={item}
              reportId={item?.id}
              lockStatus={item?.locked}
              refetchReports={refetchReports}
              isReadonly = {!myPermissions.includes(ViewPermissions.LOCK)}
            />
          </Box>
          {/* First Fellow switch */}
          <Box
            sx={{
              display: 'flex', 
              borderTop: '1px solid',
              borderColor: 'primary.lightGray',
              padding: '12px',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <FirstFellowSwitch
              row={item}
              reportId={item?.id}
              lockStatus={item?.locked}
              refetchReports={refetchReports}
            />
          </Box>
        </Box>
        
      )))}
    </Stack>
  )
}

export default PatientReportsList